import { IAuthToken } from '../models/auth';
import { IInmateMail } from '../models/inmate_mail';
import { IInmateRequest } from '../models/inmate_request';
import { ApiSuccessResponse, IApiService } from '../services/api_service';

export const inmateRequest = (centralApi: IApiService, getToken: () => IAuthToken) => ({
  get: (id): Promise<IInmateRequest> => {
    if (id == null) {
      return Promise.resolve(null);
    }
    return centralApi.get(`/inmate-request/${id}`);
  },
  put: (inmateRequestId: number, data): Promise<ApiSuccessResponse<void>> => {
    return centralApi.put(`/inmate-request/${inmateRequestId}`, data);
  },
  post: (data: FormData): Promise<ApiSuccessResponse<IInmateRequest>> => {
    return centralApi.post('/inmate-request', data, {
      contentType: false
    });
  },
  postMultiple: (data: FormData): Promise<ApiSuccessResponse<IInmateRequest>> => {
    return centralApi.post('/inmate-request/multiple', data, {
      contentType: false
    });
  },
  postResponse: (inmateRequestId: number, data: FormData): Promise<ApiSuccessResponse<IInmateMail>> => {
    return centralApi.post(`/inmate-request/${inmateRequestId}/response`, data, {
      contentType: false
    });
  },
  deleteAttachment: (mailId: number): Promise<ApiSuccessResponse<any>> => {
    return centralApi.delete(`/inmate-request/${mailId}/asset`);
  },
  pdfUrl: (ids: string): string => {
    return centralApi.buildUrl('/inmate-request.pdf', {
      ids,
      includeEmails: true,
      token: getToken().accessToken
    });
  }
});
